import React from 'react';

// Styles & Assets
import styles from './CVCharts.module.css';

// Hooks
import { useState } from 'react';

// Components
import PatientChartButtons from '../PatientChartButtons/PatientChartButtons';
import CVChart from '../CVChart/CVChart';

// Interfaces
import { Case } from '../../../interfaces/Patient';
import { DataElement } from '../../../interfaces/PhysiologicalMonitoring';
import { Parameter } from '../../../interfaces/Profile';

const CVCharts: React.FC<{
    caso: Case
    elements: DataElement[]
    sheetParameters: Parameter[]
}> = ({ caso, elements, sheetParameters }) => {

    const [activeIndicators, setActiveIndicators] = useState<string[]>([sheetParameters?.[0]?.id ?? '']);

    return (
        <>
            <div className={styles.CVChartContainer}>
                <CVChart
                    key={activeIndicators[0]}
                    parameters={sheetParameters?.filter(p => activeIndicators.some(id => id === p.id)) ?? []}
                    caso={caso}
                    elements={elements}
                />
            </div>
            <PatientChartButtons
                sheetParameters={sheetParameters}
                activeIndicators={activeIndicators}
                setActiveIndicators={setActiveIndicators} />
        </>
    );
};

export default CVCharts;